const config = {
  appName: parse(process.env.VUE_APP_NAME, 'TripCircuit'),
  appEnvironment: parse(process.env.VUE_APP_ENVIRONMENT, 'production'),
  amadeusEnvironment: parse(process.env.VUE_APP_AMADEUS_ENVIRONMENT, 'sandbox'),
  appVersion: parse(process.env.VUE_APP_VERSION, '1.0.0'),
  apiBaseUrl: parse(process.env.VUE_APP_API_BASE_URL,  'http://localhost:8081'),
  locale: parse(process.env.VUE_APP_LOCALE, 'en'),
  sso: {
    enabled: parse(process.env.VUE_APP_SSO_ENABLED, false)
  },
  huddleLabsToken: parse(process.env.VUE_APP_API_KEY_HUDDLELABS,  null),
  airHexToken: parse(process.env.VUE_APP_API_KEY_AIRHEX,  null),
  huddleLabsEndPoint: parse(process.env.VUE_APP_API_ENDPOINT_HUDDLELAB,  null),
  airHexEndPoint: parse(process.env.VUE_APP_API_ENDPOINT_AIRHEX,  null),
  localEndPoint: parse(process.env.VUE_APP_API_ENDPOINT_LOCAL,  null),
  contactId: parse(process.env.VUE_APP_API_CONTACT_ID, null),
  policyID: parse(process.env.VUE_APP_API_POLICY_ID, null),
  googleKey: parse(process.env.VUE_APP_API_GOOGLE_KEY, null),
  sparkpostApiKey: parse(process.env.VUE_APP_SPARKPOST_API_KEY, null),
  twilioAccountSid: parse(process.env.VUE_APP_TWILIO_ACCOUNT_SID, null),
  twilioApiKey: parse(process.env.VUE_APP_API_KEY, null),
  twilioApiSecret: parse(process.env.VUE_APP_API_SECRET, null),
  twilioAuthToken: parse(process.env.VUE_APP_TWILIO_AUTH_TOKEN, null),
  twilioFromPhoneNumber: parse(process.env.VUE_APP_TWILIO_FROM_PHONE_NUMBER, null),

  // JK - New HuddleLabs API
  huddlelabsApiBaseUrl: parse(process.env.VUE_APP_HUDDLELABS_API_BASE_URL, null),
  huddlelabsApiUsername: parse(process.env.VUE_APP_HUDDLELABS_API_USERNAME, null),
  huddlelabsApiPassword: parse(process.env.VUE_APP_HUDDLELABS_API_PASSWORD, null),
  previewMode: parse(process.env.VUE_APP_PREVIEW_MODE, null),
  currentVersionIndicatorUrl: parse(process.env.VUE_APP_CURRENT_VERSION_INDICATOR_URL, 'https://version.tripcircuit.com'),


// logout timers
  timeWarning: parse(process.env.VUE_APP_WARNING_MINUTES*60000, 960000),
  timeLogout: parse(process.env.VUE_APP_LOGOUT_MINUTES*60000, 900000),
  timeRefresh: parse(process.env.VUE_APP_REFRESH_MINUTES*60000, 900000),
  routerTimer: parse(process.env.VUE_APP_ROUTER_TIMER_MINUTES*60000, 900000),

// PNR timers
  updatingTimePNR: parse(process.env.VUE_APP_UPDATE_PNR_SEC*1000, 120000),
  timeLimitPNR: parse(process.env.VUE_APP_TIME_LIMIT_PNR_SEC*1000, 500),

  features: {
  },

  // Flight Stats API
  flightsStatsApiBaseUrl: parse(process.env.VUE_APP_FLIGHTS_STATS_API_URL, null),
  flightsStatsAppId: parse(process.env.VUE_APP_FLIGHTS_STATS_APP_ID, null),
  flightsStatsAppKey: parse(process.env.VUE_APP_FLIGHTS_STATS_API_KEY, null),

  // GantGateway
  gantGatewayUrl: parse(process.env.VUE_APP_GANT_GATEWAY_URL, 'https://gantgateway.com'),
  gantGatewayUrlWithProxy: parse(process.env.VUE_APP_GANT_GATEWAY_URL_PROXY, 'https://gantgateway.com'),
  gantGatewayClientId: parse(process.env.VUE_APP_GANT_GATEWAY_CLIENT_ID, null),
  gantGatewayClientSecret: parse(process.env.VUE_APP_GANT_GATEWAY_CLIENT_SECRET, null),
  gantGatewayGrantType: parse(process.env.VUE_APP_GANT_GATEWAY_GRANT_TYPE, 'password'),
  gantGatewayScope: parse(process.env.VUE_APP_GANT_GATEWAY_SCOPE, '*'),

}
function feature (name) {
  return config.features[name]
}
function parse (value, fallback) {
  // // console.log(value)
  if (typeof value === 'undefined') {
    return fallback
  }
  switch (typeof fallback) {
    case 'boolean' :
      return !!JSON.parse(value)
    case 'number' :
      return JSON.parse(value)
    default :
      return value
  }
}
export {
  config
}
export default {
  install (Vue) {
    Vue.appConfig = config
    Vue.feature = feature
    Vue.prototype.$appConfig = config
    Vue.prototype.$feature = feature
  }
}
